import type { MessengerBridge, ThemeScheme } from './types'

const mapTheme = (scheme: string | undefined): ThemeScheme =>
  scheme === 'dark' ? 'dark' : 'light'

type MaxBackButton = {
  show?: () => void
  hide?: () => void
  onClick?: (callback: () => void) => void
  offClick?: (callback: () => void) => void
}

export const createMaxBridge = (): MessengerBridge => {
  const webApp = window.WebApp

  if (!webApp) {
    throw new Error('MAX WebApp SDK is not available')
  }

  let backHandler: (() => void) | null = null

  return {
    platform: 'max',

    getInitData() {
      return webApp.initData ?? ''
    },

    getStartParam() {
      return webApp.initDataUnsafe?.start_param ?? null
    },

    getTheme() {
      const scheme = (webApp as { colorScheme?: string }).colorScheme
      return mapTheme(scheme)
    },

    ready() {
      ;(webApp as { ready?: () => void }).ready?.()
    },

    expand() {
      ;(webApp as { expand?: () => void }).expand?.()
    },

    close() {
      ;(webApp as { close?: () => void }).close?.()
    },

    setBackHandler(handler) {
      const backButton = (webApp as { BackButton?: MaxBackButton }).BackButton
      if (!backButton) {
        return
      }
      if (backHandler) {
        backButton.offClick?.(backHandler)
        backHandler = null
      }
      if (handler) {
        backHandler = handler
        backButton.onClick?.(handler)
        backButton.show?.()
      } else {
        backButton.hide?.()
      }
    },
  }
}
